function toRatio(height = 1080, width = 1080) {
  const difference = height / width;

  if (difference === 1) return 4 / 4;
  if (difference < 0.76 && difference > 0.6) return 5 / 4;
  if (difference < 1) return 1.91 / 1;
  if (difference > 1) return 4 / 5;
}

function toPixels(ratio = 1, maxSize = 1080) {
  switch (true) {
    case ratio === 1:
      return {
        width: maxSize,
        height: maxSize
      };

    case ratio < 1:
      return {
        width: maxSize * ratio,
        height: maxSize
      };

    case ratio > 1:
      return {
        width: maxSize,
        height: maxSize / ratio
      };
  }
}

export default { toRatio, toPixels };
